import SplitDistributionDashboard from '../components/statistics/SplitDistributionDashboard';

function StatisticsSplitPage() {
  return <SplitDistributionDashboard />;
}

export default StatisticsSplitPage;
